import { featureFlagSlugs } from '@/constants/featureFlagSlugs';
import { newFeatures } from '@/constants/newFeatures';
import { uselocalStorageGetterSetter } from '@/composables/uselocalStorageGetterSetter';

export default defineNuxtRouteMiddleware(async () => {
  const { getNewFeaturesObject, setNewFeaturesObject } =
    uselocalStorageGetterSetter();

  const useFeatureFlagsStore = useFeatureFlags();

  await useFeatureFlagsStore.fetchFlagByName(
    featureFlagSlugs.transportLBV2RequestEta
  );

  const updateETAIsNewObj = {
    [newFeatures.isUpdateEtaNewManage]: true,
  };

  const newFeaturesObj = getNewFeaturesObject();

  if (!newFeaturesObj) {
    setNewFeaturesObject(updateETAIsNewObj);
  }

  if (newFeaturesObj[newFeatures.isUpdateEtaNewManage] === undefined) {
    setNewFeaturesObject(updateETAIsNewObj);
  }
});
